import { render, staticRenderFns } from "./LoginBoard.vue?vue&type=template&id=bb3ebaac&scoped=true"
import script from "./LoginBoard.vue?vue&type=script&lang=js"
export * from "./LoginBoard.vue?vue&type=script&lang=js"
import style0 from "./LoginBoard.vue?vue&type=style&index=0&id=bb3ebaac&prod&scoped=true&lang=css"
import style1 from "./LoginBoard.vue?vue&type=style&index=1&id=bb3ebaac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3ebaac",
  null
  
)

export default component.exports